document.addEventListener('DOMContentLoaded', function() {

    //Load more products
    const load_btn = document.querySelector(".custom-filter-load-more");
    let products_on_page = document.querySelector('.collection-grid');
    let url = products_on_page.getAttribute('data-next-url');
    const spinner = document.querySelector('.load-more-spinner');

    if (load_btn) {
        if (url === '') {
            load_btn.style.display = 'none';
        }
    
        load_btn.addEventListener("click", ()=> {
    
            spinner.classList.add("show");
            load_btn.classList.add("loading");

            fetch(url)
                .then(function (response) {
                    if (response.ok) {
                        return response.text();
                    } else {
                        throw new Error('Network response was not ok.');
                    }
                })
                .then(function (data) {
                    const html = document.createElement('div');
                    html.innerHTML = data;
            
                    let new_grid = html.querySelector('.collection-grid');
                    url = new_grid.getAttribute('data-next-url');
                    if (url === '') {
                        load_btn.style.display = 'none';
                    }
                    let new_products = new_grid.querySelectorAll(".product-card");
            
                    new_products.forEach(new_prod => {
                        products_on_page.append(new_prod);
                    });
                    spinner.classList.remove("show");
                    load_btn.classList.remove("loading");
                })
                .catch(function (error) {
                    window.log(error);
                });       
            
    
        })
    }

    // Toolbar actions
    const toolbarFilterActions = document.querySelectorAll('.toolbar-actions .action[data-action="filter"]');
    toolbarFilterActions.forEach((action) => {
        action.addEventListener('click', (e) => {
            const filterContainerWrapper = document.querySelector('.filter-container-wrapper');
            const filterWrapper = document.querySelector('#qf-filter-wrapper');

            filterWrapper.classList.toggle('filter-active');
            filterContainerWrapper.classList.toggle('active');
        });
    });

    const toolbarGridActions = document.querySelectorAll('.toolbar-actions .action-grid > div');
    toolbarGridActions.forEach((action) => {
        action.addEventListener('click', (e) => {
            e.preventDefault();
            const data = action.getAttribute('data-action');

            toolbarGridActions.forEach((action) => {
                action.classList.remove('active');
            });

            action.classList.add('active');

            if (data == 'grid-large') {
                products_on_page.classList.add('grid-large');
            } else {
                products_on_page.classList.remove('grid-large');
            }
        });
    });

    const toolbarImageActions = document.querySelectorAll('.toolbar-actions .action-img > div');
    toolbarImageActions.forEach((action) => {
        action.addEventListener('click', (e) => {
            e.preventDefault();
            const data = action.getAttribute('data-action');

            toolbarImageActions.forEach((action) => {
                action.classList.remove('active');
            });

            action.classList.add('active');

            const allProducts = document.querySelectorAll('.collection-grid .product-card');

            if (data == 'img-alt') {
                allProducts.forEach((product) => {
                    const imageHover = product.querySelector('.image-hover');
                    imageHover.style.opacity = 1;
                });
            } else {
                allProducts.forEach((product) => {
                    const imageHover = product.querySelector('.image-hover');
                    imageHover.style.opacity = 0;
                });
            }
        });
    });

    const mobileControl = document.querySelector(".mobile-filter-heading")
    const mobileFilterBody = document.querySelector(".custom-filter-wrapper")
    const toolbarMobileActions = document.querySelectorAll('.toolbar-mobile-actions [data-action="filter"]');
    
    if (toolbarMobileActions) {
        toolbarMobileActions.forEach((action) => {
            action.addEventListener('click', () => {
                if(mobileControl.classList.contains("open")){
                    mobileControl.classList.remove("open");
                } else {  
                    mobileControl.classList.add("open");
                }
    
                if(mobileFilterBody.classList.contains("open")){
                    mobileFilterBody.classList.remove("open");
                } else {  
                    mobileFilterBody.classList.add("open");
                }

                if(document.body.classList.contains("fixed")){
                    document.body.classList.remove("fixed")
                } else {  
                    document.body.classList.add("fixed")
                }
            })
        })
    }

    let custom_filters = document.querySelectorAll(".custom-filter")

    custom_filters.forEach((el)=>{

        let control = el.querySelector(".filter-heading")
        let body = el.querySelector(".filter-body")

        if(control && body){

            control.addEventListener('click', () => {

                if(el.classList.contains("open")){
                    el.classList.remove("open")
                } else {  
                    el.classList.add("open")
                }

            })
        }
    })

    let mobile_control = document.querySelector(".mobile-filter-heading")
    let filter_body = document.querySelector(".custom-filter-wrapper")

    if(mobile_control && filter_body){
        mobile_control.addEventListener('click', () => {
            if(mobile_control.classList.contains("open")){
                mobile_control.classList.remove("open")
            } else {  
                mobile_control.classList.add("open")
            }

            if(filter_body.classList.contains("open")){
                filter_body.classList.remove("open")
            } else {  
                filter_body.classList.add("open")
            }

            if(document.body.classList.contains("fixed")){
                document.body.classList.remove("fixed")
            } else {  
                document.body.classList.add("fixed")
            }
        })
    }

    // Hide reset filters when no filters active
    const reset_filters = document.querySelector('.reset-filter-wrapper');
    const selected_filters_html = document.querySelectorAll('.selected-filter-wrapper *');
    
    if (selected_filters_html.length > 0) {
        reset_filters.style.display = 'block';
    }

    selected_filters_html.forEach(selected => {
        selected.addEventListener('click', () => {
            collection_grid.classList.add("loading")
        })
    })

    // Submit form on input change
    const filter_apply  = document.querySelector('.filter-container-wrapper .filter-apply');
    const filter_inputs = document.querySelectorAll('.filter-container-wrapper select, .filter-container-wrapper input');
    const filter_form = document.querySelector('.filter-container');
    const reset_filter = document.querySelector('#reset-filters');
    const collection_grid = document.querySelector('.collection-grid');

    filter_apply.addEventListener('click', (e) => {
        e.preventDefault();

        collection_grid.classList.add("loading");
        filter_form.submit()
    });

    reset_filter.addEventListener('click', () => {
        collection_grid.classList.add("loading");
    })


})